import { toaster } from "../components/toaster";
import { DefaultService } from "../generated";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useInvoiceLinesUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["invoiceLinesUpdate"],
    mutationFn: DefaultService.fakturInvoicesViewsInvoiceLinesUpdate,
    onSuccess: () => {
      toaster.success({ title: "Fakturalinjer oppdatert!" });
      queryClient.invalidateQueries({ queryKey: ["invoiceDetail"] });
      queryClient.invalidateQueries({ queryKey: ["invoiceList"] });
    },
  });
};
